import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { isValidHexColor } from '@openx/utils/lib/isValidHexColor';
import type { TooltipPayload } from 'recharts';
import { palette } from '../../../theme/paletteV2';

type TooltipContentProps = {
  payload?: TooltipPayload;
  totalValueSum: number;
};

export const TooltipContent = ({ payload, totalValueSum }: TooltipContentProps) => {
  if (!payload?.[0]?.name || payload?.[0]?.value == null || !totalValueSum) {
    return null;
  }

  return (
    <Paper elevation={0} sx={{ p: 2, border: `1px solid ${palette.divider}` }} data-test="tooltip">
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, alignItems: 'center' }}>
        {isValidHexColor(payload[0].payload?.color) && (
          <Box
            data-test="tooltip-color"
            sx={{ width: 12, height: 12, backgroundColor: payload[0].payload?.color, borderRadius: '50%' }}
          />
        )}
        <Typography data-test="tooltip-label" sx={{ display: 'flex' }}>
          {payload[0].name}
          <Typography
            variant="body1Bold"
            data-test="tooltip-value"
            component={'span'}
            sx={{
              marginLeft: 1,
              display: 'flex',
            }}
          >
            {((+payload[0].value / totalValueSum) * 100).toFixed(1)}%
          </Typography>
        </Typography>
      </Box>
    </Paper>
  );
};
